module.exports = __webpack_public_path__ + "img/login-page-bgimg-characters.ef38549d.webp";